import React from 'react';

const BaccaratV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.49713 3.54114C1.69186 3.54114 1.03906 4.19394 1.03906 4.99921V12.3724C1.03906 12.5996 1.11873 12.8197 1.26421 12.9943C5.80826 18.4471 14.1833 18.4471 18.7273 12.9943C18.8728 12.8197 18.9525 12.5996 18.9525 12.3724V4.99921C18.9525 4.19394 18.2997 3.54114 17.4944 3.54114H2.49713ZM2.28884 4.99921C2.28884 4.88417 2.38209 4.79091 2.49713 4.79091H17.4944C17.6095 4.79091 17.7027 4.88417 17.7027 4.99921V12.2709C13.6656 17.0219 6.32595 17.0219 2.28884 12.2709V4.99921ZM4.99623 8.12367H14.9944V6.8739H4.99623V8.12367ZM5.82952 10.8317C5.82952 11.2918 5.45649 11.6648 4.99634 11.6648C4.53619 11.6648 4.16316 11.2918 4.16316 10.8317C4.16316 10.3715 4.53619 9.99848 4.99634 9.99848C5.45649 9.99848 5.82952 10.3715 5.82952 10.8317ZM14.9951 11.6648C15.4553 11.6648 15.8283 11.2918 15.8283 10.8317C15.8283 10.3715 15.4553 9.99848 14.9951 9.99848C14.535 9.99848 14.1619 10.3715 14.1619 10.8317C14.1619 11.2918 14.535 11.6648 14.9951 11.6648ZM9.16568 12.4978C9.16568 12.958 8.79265 13.331 8.3325 13.331C7.87235 13.331 7.49932 12.958 7.49932 12.4978C7.49932 12.0376 7.87235 11.6646 8.3325 11.6646C8.79265 11.6646 9.16568 12.0376 9.16568 12.4978ZM11.6628 13.331C12.123 13.331 12.496 12.958 12.496 12.4978C12.496 12.0376 12.123 11.6646 11.6628 11.6646C11.2027 11.6646 10.8297 12.0376 10.8297 12.4978C10.8297 12.958 11.2027 13.331 11.6628 13.331Z",
      fill: "white"
    }
  )
);

export { BaccaratV2 };
//# sourceMappingURL=BaccaratV2.js.map
